import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = process.env.REACT_APP_API_URL || "http://localhost:5002";

export default function ForgotPasswordDriver() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${API}/api/chauffeurs/forgot-password`, {
        email: email.trim().toLowerCase(),
      });

      setMessage(
        res.data?.message ||
          "Si un compte chauffeur existe avec cette adresse, un email de réinitialisation a été envoyé."
      );
      setEmail("");
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "Erreur lors de la demande de réinitialisation."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.topRow}>
          <Link to="/" style={styles.backLink}>
            ← Retour à l’accueil
          </Link>
        </div>

        <h1 style={styles.title}>Mot de passe oublié — Chauffeur</h1>
        <p style={styles.text}>
          Saisis ton adresse email pour recevoir un lien sécurisé de
          réinitialisation de ton mot de passe.
        </p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <label htmlFor="email" style={styles.label}>
            Adresse email
          </label>

          <input
            id="email"
            type="email"
            placeholder="ex: chauffeur@dieli.fr"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            style={styles.input}
          />

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? "Envoi..." : "Recevoir le lien"}
          </button>
        </form>

        {message ? <p style={styles.success}>{message}</p> : null}
        {error ? <p style={styles.error}>{error}</p> : null}

        <div style={styles.footer}>
          <Link to="/" style={styles.footerLink}>
            Revenir à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(180deg, #070708 0%, #0b0b0f 45%, #101218 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  card: {
    width: "100%",
    maxWidth: "520px",
    background: "rgba(19,19,26,0.96)",
    border: "1px solid rgba(212,175,55,0.18)",
    borderRadius: "22px",
    padding: "28px",
    color: "#fff",
    boxShadow: "0 18px 45px rgba(0,0,0,0.35)",
  },
  topRow: {
    marginBottom: "8px",
  },
  backLink: {
    color: "#d4af37",
    textDecoration: "none",
    fontWeight: 700,
    fontSize: "14px",
  },
  title: {
    marginTop: 0,
    marginBottom: "10px",
    fontSize: "28px",
    lineHeight: 1.2,
  },
  text: {
    color: "#cfcfd6",
    marginBottom: "22px",
    lineHeight: 1.55,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  label: {
    color: "#f5f5f5",
    fontWeight: 700,
    fontSize: "14px",
  },
  input: {
    padding: "14px 16px",
    borderRadius: "14px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "#0f0f14",
    color: "#fff",
    outline: "none",
    fontSize: "15px",
  },
  button: {
    marginTop: "4px",
    padding: "14px",
    borderRadius: "14px",
    border: "none",
    background: "#d4af37",
    color: "#111",
    fontWeight: 800,
    fontSize: "15px",
    cursor: "pointer",
  },
  success: {
    color: "#86efac",
    marginTop: "16px",
    lineHeight: 1.5,
  },
  error: {
    color: "#fca5a5",
    marginTop: "16px",
    lineHeight: 1.5,
  },
  footer: {
    marginTop: "18px",
    textAlign: "center",
  },
  footerLink: {
    color: "#d4af37",
    textDecoration: "none",
    fontWeight: 700,
  },
};